// extracted by mini-css-extract-plugin
export default {"rootClassName":"tooltip-manager"};